<template>
  <b-collapse :id="tableId"
              @shown="onShown"
              @hidden="onHidden"
              role="tabpanel"
              v-model="visible">
    <slot></slot>
  </b-collapse>
</template>

<script>
  import {StorageService} from "../../services/storage.service";

  export default {
    name: "SearchCollapse",
    data() {
      return {
        visible: false
      }
    },
    props: {
      tableId: {
        type: String,
        required: true
      }
    },
    methods: {
      onShown() {
        StorageService.setTableCollapseState(this.tableId, this.visible);
      },
      onHidden() {
        StorageService.setTableCollapseState(this.tableId, this.visible);
      }
    },
    async mounted() {
      this.visible = await StorageService.getTableCollapseState(this.tableId);
    }
  }
</script>

<style scoped>

</style>
